import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const C = {
  maroon: '#5B1818', maroonDark: '#3B0E0E', gold: '#C9A23A', goldLight: '#E2C170', goldSoft: '#F0DCA0',
  cream: '#0B0B0E', creamWarm: '#17171C', creamDeep: '#101014',
  text: '#F2EDE3', textMuted: '#BDB6AB',
  border: 'rgba(201, 162, 58, 0.35)', borderStrong: 'rgba(201, 162, 58, 0.55)',
  success: '#E2C170',
};

const SADHANA_AMOUNT = 3200;

const SERVICES = {
  call: { amount: 5100, title: 'माता जी से 30 मिनट व्यक्तिगत Phone Consultation', breakdown: [['30 मिनट व्यक्तिगत परामर्श', '₹5100']] },
  visit: { amount: 51000, title: 'माता जी से व्यक्तिगत भेंट (दरबार में)', breakdown: [['व्यक्तिगत भेंट दक्षिणा', '₹51000']] },
  sadhana40: { amount: 3300, title: '3 रात्रि गुप्त साधना (40% छूट)', breakdown: [['साधना दक्षिणा', '₹5500'], ['विशेष छूट (40%)', '− ₹2200']] },
  sadhana: { amount: SADHANA_AMOUNT, title: '3 रात्रि गुप्त साधना', breakdown: [['सामग्री शुल्क (नारियल, गुग्गल, हवन-सामग्री, यंत्र-धातु)', '₹2100'], ['अघोरी भोग (प्रसाद सहित)', '₹1100']] },
  consult2100: { amount: 2100, title: 'माता जी से 30 मिनट Consultation Call (विशेष छूट)', breakdown: [['परामर्श शुल्क (30 मिनट)', '₹5500'], ['विशेष कृपा छूट', '− ₹3400']] },
};

const PaymentPage = () => {
  const { leadId } = useParams();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const serviceKey = searchParams.get('service');
  const customAmt = parseInt(searchParams.get('amt') || '', 10);
  let service = SERVICES[serviceKey] || SERVICES.sadhana;
  if (serviceKey === 'custom' && customAmt >= 101 && customAmt <= 51000) {
    service = {
      amount: customAmt,
      title: '3 रात्रि गुप्त साधना (विशेष)',
      breakdown: [
        ['साधना दक्षिणा (अभी देय)', `₹${customAmt}`],
        ['शेष दक्षिणा', 'कार्य सफल होने पर'],
        ...(customAmt < 1100 ? [['प्रसाद (सिद्ध यंत्र)', 'इस राशि में नहीं — ₹1100 पर मिलेगा']] : []),
      ],
    };
  }
  const isChooser = false; // fixed ₹3200 — report/email से match
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [chosenAmt, setChosenAmt] = useState(1100);
  const [customInput, setCustomInput] = useState('');

  const effService = isChooser
    ? {
        amount: chosenAmt,
        title: '3 रात्रि गुप्त साधना',
        breakdown: [
          ['साधना दक्षिणा (इच्छानुसार)', `₹${chosenAmt}`],
          chosenAmt >= 1100
            ? ['प्रसाद (सिद्ध यंत्र) घर पर', 'सम्मिलित ✓']
            : ['प्रसाद (सिद्ध यंत्र)', '₹1100 से कम में नहीं'],
        ],
      }
    : service;

  // Delivery form
  const [form, setForm] = useState({
    full_name: '',
    mobile: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
  });

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const res = await fetch(`/api/report/${leadId}`);
        const data = await res.json();
        if (!data.error) {
          setReportData(data);
          setForm(prev => ({
            ...prev,
            full_name: data.name || '',
            mobile: data.mobile1 || '',
          }));
          if (data.payment_status === 'paid') navigate(`/thank-you/${leadId}`);
        }
      } catch (err) { console.error('Fetch report failed:', err); }
      setLoading(false);
    };
    fetchReport();

    // Load Razorpay Checkout SDK
    if (!document.querySelector('script[src*="checkout.razorpay.com"]')) {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, [leadId, navigate]);

  const validate = () => {
    if (!form.full_name.trim()) return 'पूरा नाम भरें';
    if (!/^\d{10}$/.test(form.mobile.trim())) return 'सही 10-digit मोबाइल नंबर भरें';
    if (form.address.trim().length < 10) return 'पूरा पता भरें (कम से कम 10 अक्षर)';
    if (!form.city.trim()) return 'शहर भरें';
    if (!form.state.trim()) return 'राज्य भरें';
    if (!/^\d{6}$/.test(form.pincode.trim())) return 'सही 6-digit pincode भरें';
    return null;
  };

  const handlePayment = async () => {
    const err = validate();
    if (err) { setError(err); return; }
    setError(null);
    setProcessing(true);

    try {
      // Step 1: Save delivery details first (before payment)
      await fetch('/api/address/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lead_id: leadId, ...form }),
      });

      // Step 2: Create Razorpay order
      const orderRes = await fetch('/api/payment/create-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lead_id: leadId, amount: effService.amount, service: serviceKey || 'sadhana' }),
      });
      const orderData = await orderRes.json();
      if (orderData.error || !orderData.order_id) {
        setError(orderData.error || 'Order creation failed');
        setProcessing(false);
        return;
      }

      // Step 3: Open Razorpay Checkout in-page
      if (!window.Razorpay) {
        setError('Payment system load नहीं हुआ। पेज refresh करें।');
        setProcessing(false);
        return;
      }

      const options = {
        key: orderData.key_id,
        amount: orderData.amount * 100,
        currency: orderData.currency || 'INR',
        name: 'माता मलिहा जी',
        description: 'गुप्त साधना दक्षिणा',
        order_id: orderData.order_id,
        prefill: {
          name: form.full_name,
          email: orderData.customer_email || reportData?.email || '',
          contact: form.mobile,
        },
        notes: {
          lead_id: leadId,
          delivery_address: `${form.address}, ${form.city}, ${form.state} - ${form.pincode}`,
        },
        theme: { color: C.goldLight },
        handler: async (response) => {
          try {
            const verifyRes = await fetch('/api/payment/verify', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                lead_id: leadId,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }),
            });
            const verifyData = await verifyRes.json();
            if (verifyData.success) navigate(`/thank-you/${leadId}`);
            else setError(verifyData.error || 'Payment verification failed');
          } catch (e) {
            setError('Payment verification failed: ' + e.message);
          }
          setProcessing(false);
        },
        modal: {
          ondismiss: () => setProcessing(false),
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', (resp) => {
        setError('Payment failed: ' + (resp?.error?.description || 'try again'));
        setProcessing(false);
      });
      rzp.open();
    } catch (e) {
      setError('Network error: ' + e.message);
      setProcessing(false);
    }
  };

  const pageStyle = { background: '#0B0B0E', fontFamily: "'Noto Sans Devanagari', sans-serif", color: C.text, minHeight: '100vh' };

  if (loading) return <div style={pageStyle} className="flex items-center justify-center"><div style={{ color: C.goldLight }} className="text-xl">Loading...</div></div>;

  const inputStyle = {
    width: '100%',
    padding: '12px 14px',
    borderRadius: 10,
    border: `1.5px solid ${C.border}`,
    background: '#1B1B20',
    color: C.text,
    fontSize: 15,
    fontFamily: "'Noto Sans Devanagari', sans-serif",
    outline: 'none',
  };

  return (
    <div style={pageStyle} data-testid="payment-page">
      <header className="py-8 px-4" style={{ background: `linear-gradient(135deg, ${C.maroonDark} 0%, ${C.maroon} 50%, ${C.maroonDark} 100%)`, borderBottom: `2px solid ${C.gold}` }}>
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-3xl mb-2" style={{ color: C.goldLight }}>ॐ</div>
          <h1 className="text-3xl font-bold" style={{ color: C.goldSoft, fontFamily: "'Tiro Devanagari Hindi', serif" }}>माता मलिहा जी</h1>
          <p className="mt-2 text-sm tracking-widest uppercase" style={{ color: C.goldLight }}>{effService.title} के लिए दक्षिणा</p>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-10">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold mb-2" style={{ color: C.goldLight, fontFamily: "'Tiro Devanagari Hindi', serif" }}>{reportData?.name} जी</h2>
          <p style={{ color: C.textMuted }}>आपकी साधना शुरू होने वाली है</p>
          <div className="mx-auto mt-4 h-px" style={{ width: 90, background: `linear-gradient(90deg, transparent, ${C.gold}, transparent)` }} />
        </div>

        {/* Amount Chooser — इच्छानुसार दक्षिणा */}
        {isChooser && (
          <section className="rounded-2xl p-6 mb-6" style={{ background: C.creamWarm, border: `1.5px solid ${C.borderStrong}` }} data-testid="amount-chooser">
            <h3 className="text-lg font-bold mb-1" style={{ color: C.goldLight, fontFamily: "'Tiro Devanagari Hindi', serif" }}>अपनी श्रद्धानुसार दक्षिणा चुनें</h3>
            <p className="text-xs mb-4" style={{ color: C.textMuted }}>जितनी श्रद्धा, उतनी दक्षिणा — प्रसाद (सिद्ध यंत्र) घर मंगवाने हेतु न्यूनतम ₹1100</p>
            <div className="flex flex-wrap gap-2 mb-3">
              {[101, 201, 301, 501, 1100, 2100, 5100].map((a) => (
                <button
                  key={a}
                  onClick={() => { setChosenAmt(a); setCustomInput(''); }}
                  data-testid={`amt-chip-${a}`}
                  className="px-4 py-2 rounded-full text-sm font-bold transition-all"
                  style={chosenAmt === a && !customInput
                    ? { background: C.gold, color: '#1a1206', border: `1.5px solid ${C.gold}` }
                    : { background: '#1B1B20', color: C.text, border: `1.5px solid ${C.border}` }}
                >
                  ₹{a}{a >= 1100 ? ' 🎁' : ''}
                </button>
              ))}
            </div>
            <div className="flex items-center gap-2">
              <input
                type="number"
                min="101"
                value={customInput}
                onChange={(e) => {
                  const v = e.target.value;
                  setCustomInput(v);
                  const n = parseInt(v, 10);
                  if (n >= 101 && n <= 51000) setChosenAmt(n);
                }}
                placeholder="या अपनी राशि लिखें (₹101 से)"
                data-testid="amt-custom-input"
                style={{ ...inputStyle, maxWidth: 260 }}
              />
            </div>
            <p className="text-xs mt-3" style={{ color: chosenAmt >= 1100 ? C.goldLight : C.textMuted }}>
              {chosenAmt >= 1100
                ? '✓ इस दक्षिणा में सिद्ध यंत्र (प्रसाद) आपके घर भेजा जाएगा'
                : '⚠ ₹1100 से कम में केवल आपके नाम की साधना होगी — प्रसाद नहीं भेजा जाएगा'}
            </p>
          </section>
        )}

        {/* Order Summary */}
        <section className="rounded-2xl p-7 mb-6" style={{ background: C.creamWarm, border: `1px solid ${C.border}`, boxShadow: '0 4px 20px rgba(0,0,0,0.55)' }} data-testid="order-summary">
          <h3 className="text-xl font-bold mb-4" style={{ color: C.goldLight, fontFamily: "'Tiro Devanagari Hindi', serif" }}>दक्षिणा विवरण</h3>
          <div className="space-y-3">
            {effService.breakdown.map(([l, v]) => (
              <div key={l} className="flex justify-between py-2" style={{ borderBottom: `1px dashed ${C.border}` }}>
                <span style={{ color: C.text }}>{l}</span>
                <span className="font-bold" style={{ color: C.goldLight }}>{v}</span>
              </div>
            ))}
            <div className="flex justify-between py-3">
              <span className="font-extrabold text-lg" style={{ color: C.goldLight }}>कुल राशि</span>
              <span className="font-extrabold text-3xl" style={{ color: C.goldLight, fontFamily: "'Tiro Devanagari Hindi', serif" }}>₹{effService.amount}</span>
            </div>
          </div>
        </section>

        {/* Delivery Details Form */}
        <section className="rounded-2xl p-7 mb-6" style={{ background: C.creamWarm, border: `1px solid ${C.border}` }} data-testid="delivery-form">
          <h3 className="text-lg font-bold mb-2" style={{ color: C.goldLight, fontFamily: "'Tiro Devanagari Hindi', serif" }}>❖ यंत्र (प्रसाद) Delivery के लिए पता भरें</h3>
          <p className="text-sm mb-4" style={{ color: C.textMuted }}>सिद्ध यंत्र आपके घर पर भेजा जाएगा। कृपया पूरा पता भरें।</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="sm:col-span-2">
              <label className="text-xs font-bold block mb-1" style={{ color: C.goldLight }}>पूरा नाम *</label>
              <input data-testid="input-full-name" style={inputStyle} type="text" value={form.full_name}
                onChange={e => setForm({ ...form, full_name: e.target.value })} placeholder="जैसे: सुनीता शर्मा" />
            </div>
            <div className="sm:col-span-2">
              <label className="text-xs font-bold block mb-1" style={{ color: C.goldLight }}>मोबाइल नंबर (Delivery के लिए) *</label>
              <input data-testid="input-mobile" style={inputStyle} type="tel" maxLength={10} value={form.mobile}
                onChange={e => setForm({ ...form, mobile: e.target.value.replace(/\D/g, '') })} placeholder="10-digit मोबाइल" />
            </div>
            <div className="sm:col-span-2">
              <label className="text-xs font-bold block mb-1" style={{ color: C.goldLight }}>पूरा पता (मकान नं., गली, मोहल्ला) *</label>
              <textarea data-testid="input-address" style={{ ...inputStyle, minHeight: 80, resize: 'vertical' }} value={form.address}
                onChange={e => setForm({ ...form, address: e.target.value })} placeholder="जैसे: मकान न. 12, राम नगर, गली नं. 3" />
            </div>
            <div>
              <label className="text-xs font-bold block mb-1" style={{ color: C.goldLight }}>शहर / गाँव *</label>
              <input data-testid="input-city" style={inputStyle} type="text" value={form.city}
                onChange={e => setForm({ ...form, city: e.target.value })} placeholder="शहर" />
            </div>
            <div>
              <label className="text-xs font-bold block mb-1" style={{ color: C.goldLight }}>राज्य *</label>
              <input data-testid="input-state" style={inputStyle} type="text" value={form.state}
                onChange={e => setForm({ ...form, state: e.target.value })} placeholder="राज्य" />
            </div>
            <div className="sm:col-span-2">
              <label className="text-xs font-bold block mb-1" style={{ color: C.goldLight }}>Pincode *</label>
              <input data-testid="input-pincode" style={inputStyle} type="tel" maxLength={6} value={form.pincode}
                onChange={e => setForm({ ...form, pincode: e.target.value.replace(/\D/g, '') })} placeholder="6-digit pincode" />
            </div>
          </div>
        </section>

        {/* What you get */}
        <section className="rounded-2xl p-7 mb-6" style={{ background: C.creamWarm, border: `1px solid ${C.border}` }}>
          <h3 className="text-lg font-bold mb-4" style={{ color: C.goldLight, fontFamily: "'Tiro Devanagari Hindi', serif" }}>आपको क्या मिलेगा</h3>
          <ul className="space-y-3" style={{ color: C.text }}>
            {['माता जी द्वारा 6-7 दिन की गुप्त साधना', 'बंधन से मुक्ति के लिए विशेष अनुष्ठान', 'सिद्ध यंत्र (प्रसाद) — घर पर डिलीवरी', 'यंत्र धारण करने की पूरी विधि'].map((t, i) => (
              <li key={i} className="flex items-start gap-3"><span style={{ color: C.success, marginTop: 2 }}>✓</span><span>{t}</span></li>
            ))}
          </ul>
        </section>

        {/* Pay Button */}
        <div className="text-center">
          {error && (
            <div className="rounded-xl p-4 mb-4 text-center" style={{ background: 'rgba(224,91,91,0.10)', border: '1px solid rgba(178,34,34,0.40)' }} data-testid="payment-error">
              <p style={{ color: '#E05B5B' }}>{error}</p>
            </div>
          )}
          <button
            onClick={handlePayment} disabled={processing} data-testid="pay-now-button"
            className="w-full text-lg sm:text-xl font-extrabold px-8 py-5 rounded-full transition-all transform hover:scale-105 disabled:scale-100 disabled:opacity-60"
            style={{ background: 'linear-gradient(135deg, #1C0606 0%, #6E0F0F 100%)', color: '#F5E7C8', border: `1px solid ${C.gold}`, boxShadow: '0 6px 24px rgba(201,162,58,0.45)', fontFamily: "'Tiro Devanagari Hindi', serif", letterSpacing: '0.03em' }}
          >
            {processing ? 'Processing…' : `अभी भुगतान करें — ₹${effService.amount}`}
          </button>
          <p className="text-sm mt-4" style={{ color: C.textMuted }}>Secured by Razorpay  |  UPI · Cards · Net Banking</p>
        </div>

        <div className="rounded-xl p-4 mt-10 text-center" style={{ background: 'rgba(201,162,58,0.05)', border: `1px solid ${C.border}` }}>
          <p className="text-sm" style={{ color: C.textMuted }}>❖ अघोर विधि से कार्य होता है | पूरी श्रद्धा-विश्वास हो तभी आएं ❖</p>
        </div>
      </main>

      <footer className="py-8 text-center" style={{ background: `linear-gradient(180deg, ${C.maroon} 0%, ${C.maroonDark} 100%)`, borderTop: `2px solid ${C.gold}` }}>
        <div className="text-2xl mb-2" style={{ color: C.gold }}>ॐ</div>
        <p className="font-bold tracking-widest" style={{ color: C.goldSoft }}>जय माता मलिहा</p>
      </footer>
    </div>
  );
};

export default PaymentPage;
